import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Incomplete20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_837)'>
      <path
        d='M10 1.75C14.5563 1.75 18.25 5.44365 18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C9.44806 18.25 8.9095 18.1959 8.38909 18.093L8.09799 19.5644C8.71375 19.6863 9.3498 19.75 10 19.75C15.3848 19.75 19.75 15.3848 19.75 10C19.75 4.61522 15.3848 0.25 10 0.25C9.3498 0.25 8.71375 0.313749 8.09799 0.435565L8.38909 1.90705C8.9095 1.8041 9.44806 1.75 10 1.75Z'
        fill='currentColor'
      />
      <path
        d='M1.89268 15.4178C2.6043 16.4807 3.51929 17.3957 4.58222 18.1073L5.4167 16.8609C4.5167 16.2583 3.74167 15.4833 3.13914 14.5833L1.89268 15.4178Z'
        fill='currentColor'
      />
      <path
        d='M4.58222 1.89268C3.51929 2.6043 2.60429 3.51929 1.89268 4.58222L3.13913 5.4167C3.74167 4.5167 4.5167 3.74167 5.4167 3.13914L4.58222 1.89268Z'
        fill='currentColor'
      />
      <path
        d='M0.435563 8.09799C0.19193 9.32951 0.19193 10.6705 0.435563 11.902L1.90704 11.6109C1.70114 10.5701 1.70114 9.4299 1.90704 8.38909L0.435563 8.09799Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_837'>
        <rect
          width='20'
          height='20'
          fill='white'
          transform='matrix(0 1 -1 0 20 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

Incomplete20.displayName = 'Incomplete20';
export default Incomplete20;
